import React from 'react';
import { TwitterPicker } from 'react-color';

import './App.css';

import { colourPickerContainerStyle, colourPickerHeadingStyle, colourPickerCardStyle } from './styles/colour-picker-styles';

const colorsList = {
	teal: '#367A66',
	gold: '#86743D',
	yellow: '#8A600D',
	taupe: '#7B725C',
	lime: '#5F8129',
	sky: '#1080A6',
	purple: '#92278F',
};

const colourValues = Object.values(colorsList);

class CalloutColourPicker extends React.Component {
	state = {
		color: colorsList.teal,
	};

	getKeyByValue = (object, value) => {
		return Object.keys(object).find(key => object[key].toLowerCase() === value);
	};

	addHighLightClass = (classToAdd, targetClass) => {
		var elements = document.getElementsByClassName(targetClass);
		elements.length &&
			elements.forEach(element => {
				element.className = targetClass + ' ' + classToAdd;
			});
	};

	handleChangeComplete = color => {
		var colorName = this.getKeyByValue(colorsList, color.hex);
		var classToAdd = 'ontario-border-highlight--' + colorName;
		this.addHighLightClass(classToAdd, 'ontario-callout');
		this.addHighLightClass(classToAdd, 'ontario-aside');
		this.setState({ color: color.hex });
	};

	render() {
		return (
			<div style={colourPickerContainerStyle}>
				<p id="colour-selector" style={colourPickerHeadingStyle}>
					{document.documentElement.lang === 'en' ? 'Colour options' : 'Options de couleur'}
				</p>
				<TwitterPicker
					aria-describedby="colour-selector"
					triangle="hide"
					colors={colourValues}
					color={this.state.color}
					onChangeComplete={this.handleChangeComplete}
					styles={colourPickerCardStyle}
				/>
			</div>
		);
	}
}

export default CalloutColourPicker;
